export default function findRowKeys(rows, rowKey, expanded) {
  var keys = [];

  for (var i = 0; i < rows.length; i++) {
    var item = rows[i];

    if (item.children) {
      keys.push(item[rowKey]);
      keys = [].concat(keys, findRowKeys(item.children, rowKey));
    } else if (expanded) {
      keys.push(item[rowKey]);
    }
  }

  return keys;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite-table/es/utils/findRowKeys.js
// module id = 2426
// module chunks = 35